<template>
  <WidgetWrapper>
    <WidgetTitle
      v-if="!loading"
      :title="$t('main.deviceDistribution.title')"
      :description="$t('main.deviceDistribution.description')"
    />
    <div v-if="isData" class="content">
      <div class="legend">
        <div class="legend-item">
          <img :src="DesktopIcon" class="legend-icon" />
          <span class="legend-dot legend-dot--desktop"></span>
          <span>{{ $t('main.deviceDistribution.WidgetListTitle') }}</span>
        </div>
        <div class="legend-item">
          <img :src="MobileIcon" class="legend-icon" />
          <span class="legend-dot legend-dot--mobile"></span>
          <span>{{ $t('main.deviceDistribution.widgetListValue') }}</span>
        </div>
      </div>
      <div
        class="device-row"
        v-for="item of dataOnActualDate"
        :key="item.domainName"
      >
        <Domain class="device-domain" :domain="item.domainName" />
        <div v-if="item.desktop != null" class="device-bar-wrapper">
          <span class="device-share">{{ item.desktop }}%</span>
          <div class="device-bar">
            <div class="device-bar-desktop" :style="{ width: item.desktop + '%' }"></div>
            <div class="device-bar-mobile" :style="{ width: item.phone + '%' }"></div>
          </div>
          <span class="device-share device-share--right">{{ item.phone }}%</span>
        </div>
        <div v-else class="no-data">—</div>
      </div>
    </div>
    <WidgetError v-if="!isData && !loading" />
    <SkeletonLoading v-if="loading" name="deviceDestribution" />
  </WidgetWrapper>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import WidgetTitle from '@/components/widgets/widgets-helpers/WidgetTitle.vue'
import SkeletonLoading from '@/components/SkeletonLoading.vue'
import WidgetError from '@/components/errors/WidgetError.vue'
import WidgetWrapper from '@/components/widgets/widgets-helpers/WidgetWrapper.vue'
import Domain from '@/components/widgets/widgets-helpers/Domain.vue'
import DesktopIcon from '@/assets/icons/devices/desktop.svg'
import MobileIcon from '@/assets/icons/devices/mobile.svg'

export default {
  data() {
    return { DesktopIcon, MobileIcon }
  },
  components: {
    WidgetTitle,
    SkeletonLoading,
    WidgetError,
    WidgetWrapper,
    Domain,
  },
  computed: {
    ...mapGetters('deviceDistribution', ['dataOnActualDate']),
    ...mapState('deviceDistribution', {
      deviceDistribution: state => state,
    }),
    isData() {
      return (
        !this.loading &&
        !this.deviceDistribution.error.status &&
        this.dataOnActualDate.length > 0
      )
    },
    loading() {
      return this.deviceDistribution.loading
    },
  },
}
</script>

<style scoped>
.legend {
  display: flex;
  gap: 20px;
  margin-bottom: 14px;
  font-size: 13px;
  color: var(--text-secondary2);
}

@media (min-width: 1200px) {
  .content {
    margin-top: 15px;
  }
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.legend-icon {
  width: 14px;
  height: 14px;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-dot--desktop {
  background: var(--main-color);
}

.legend-dot--mobile {
  background: #ec4899;
}

.device-row {
  display: flex;
  align-items: center;
  padding: 7px 0;
  gap: 16px;
}

.device-row + .device-row {
  border-top: 1px solid var(--border-color);
}

.device-domain {
  width: 120px;
  min-width: 100px;
  flex-shrink: 0;
}

.device-bar-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.device-share {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  min-width: 38px;
  text-align: right;
}

.device-share--right {
  text-align: left;
}

.device-bar {
  flex: 1;
  display: flex;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
}

.device-bar-desktop {
  height: 100%;
  background: var(--main-color);
  border-radius: 5px 0 0 5px;
}

.device-bar-mobile {
  height: 100%;
  background: #ec4899;
  border-radius: 0 5px 5px 0;
}

.no-data {
  color: var(--text-secondary3);
  font-size: 13px;
}
</style>
